
import { defineComponent } from 'vue';
import ModalMessage from '@/components/ModalMessage.vue';
import axios from 'axios';

export default defineComponent({
  name: 'ConfirmView',
  data() {
    return {
      userMessage: 'Uw aanvraag wordt bevestigd....',
    };
  },
  async created() {
    const data = {
      Hash: this.$route.hash.replace(/^#/, ''),
    };

    const res = await fetch('/umbraco/api/Gateway/ConfirmEmailAddress', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();

    this.userMessage = resData.Message;
    let origin: string;
    if (this.$route.query.origin?.toString()) {
      origin = this.$route.query.origin?.toString();
      // eslint-disable-next-line
      setTimeout(() => { window.location.href = origin; }, 1000);
    }
  },
});
